import {useMemo} from "react";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import {sortBy} from "lodash-es";
import type {GeoHit} from "instantsearch.js";
import {type Practice} from "../components/PracticesMapContainer.tsx";
import {metersToMiles} from "../lib/utils.ts";
import {useApp} from "../providers/AppProvider.tsx";

export const useSortedPractices = (items: GeoHit<Practice>[]) => {
    const {state} = useApp();
    const map = useMap();
    const geometry = useMapsLibrary('geometry')

    return useMemo<GeoHit<Practice>[]>(() => {
        if (!map?.getCenter()) {
            return items
        }
        return sortBy(items.map(item => ({
            ...item,
            _rankingInfo: {
                ...item._rankingInfo,
                // @ts-expect-error bug
                geoDistance: metersToMiles(geometry?.spherical.computeDistanceBetween(item._geoloc, state.userPickedLocation?.geometry?.location ?? map?.getCenter()))
            }
        })), '_rankingInfo.geoDistance') as GeoHit<Practice>[];

    }, [geometry?.spherical, items, map, state.userPickedLocation])
}
